import * as React from 'react';
import {observer} from 'mobx-react';
import {PageAccountLinkedAccount} from './page-account-linked-account';
import {SVGIcon} from './svg-icon';
import {colorDropbox, colorSpotify, colorTwitter} from '../theme/color';
import {vertical, verticallySpaced} from 'csstips';
import {style} from 'typestyle';

export interface PageAccountLinkedAccountsModel {
  spotify: LinkedAccountModel;
  twitter: LinkedAccountModel;
  dropbox: LinkedAccountModel;
  facebook: LinkedAccountModel;
}

export interface PageAccountLinkedAccountsProps {
  model: PageAccountLinkedAccountsModel;
  onLinkTwitter(event: React.MouseEvent<any>): void;
  onUnlinkSpotify(): void;
  onUnlinkTwitter(): void;
  onUnlinkDropbox(): void;
  onUnlinkFacebook(): void;
  i18n?: {
    spotify: LinkedAccountI18n;
    twitter: LinkedAccountI18n;
    dropbox: LinkedAccountI18n;
    facebook: LinkedAccountI18n;
  }
}

export interface LinkedAccountModel {
  name: string;
  linkURL: string;
  isLinked: boolean;
  isUnlinking: boolean;
}

export interface LinkedAccountI18n {
  link: string;
  unlink: string;
  unlinking: string;
  header: string;
  content: string;
}

const DEFAULT_I18N = {
  spotify: {
    link: 'Link my Spotify account',
    unlink: 'Unlink my Spotify account',
    unlinking: 'Unlinking Spotify account...',
    header: 'Why should I link my Spotify account?',
    content: 'If you link your Spotify account we can help you keep up to date with new releases and music on Lickd. We can even give you your own discover weekly of tracks we think you\'d like to hook for your next video'
  },
  twitter: {
    link: 'Link my Twitter account',
    unlink: 'Unlink my Twitter account',
    unlinking: 'Unlinking Twitter account...',
    header: 'Why should I link my Twitter account?',
    content: 'Help us to help you! Tell other creators about your hooks and help us raise the game and get even better content on Lickd.'
  },
  dropbox: {
    link: 'Link my Dropbox account',
    unlink: 'Unlink my Dropbox account',
    unlinking: 'Unlinking Dropbox account...',
    header: 'Why should I link my Dropbox account?',
    content: 'Why not? It\'s simple, convenient, and means you can hook a track on the go and it\'ll be in your Dropbox when you get home.'
  },
  facebook: {
    link: 'Link my Facebook account',
    unlink: 'Unlink my Facebook account',
    unlinking: 'Unlinking Facebook account...',
    header: 'Why should I link my Facebook account?',
    content: 'Let us know who you like on Facebook and we\'ll tell you what you might like on Lickd! We can tell you when artists you follow arrive on Lickd as well as suggest alternatives.'
  }
};

export const PageAccountLinkedAccounts = observer<PageAccountLinkedAccountsProps>(
  ({ i18n = DEFAULT_I18N, model, onLinkTwitter, onUnlinkSpotify, onUnlinkTwitter, onUnlinkFacebook, onUnlinkDropbox }) => (
    <div className={styles.container}>
      <PageAccountLinkedAccount
        {...model.spotify}
        i18n={i18n.spotify}
        Icon={SVGIcon.Spotify}
        color={colorSpotify}
        onUnlink={onUnlinkSpotify}
      />
      <PageAccountLinkedAccount
        {...model.twitter}
        i18n={i18n.twitter}
        Icon={SVGIcon.Twitter}
        color={colorTwitter}
        onLink={onLinkTwitter}
        onUnlink={onUnlinkTwitter}
      />
      <PageAccountLinkedAccount
        {...model.dropbox}
        i18n={i18n.dropbox}
        Icon={SVGIcon.Dropbox}
        color={colorDropbox}
        onUnlink={onUnlinkDropbox}
      />
      {/*<PageAccountLinkedAccount*/}
        {/*{...model.facebook}*/}
        {/*i18n={i18n.facebook}*/}
        {/*Icon={SVGIcon.Facebook}*/}
        {/*color={colorFacebook}*/}
        {/*onUnlink={onUnlinkFacebook}*/}
      {/*/>*/}
    </div>
  )
);


const styles = {
  container: style({
    ...vertical,
    ...verticallySpaced(40)
  })
};